import { storageService } from '@/services/storage'

import type { ComparisonOfferInput, ComparisonPriceHistoryEntry } from './ComparisonTypes'

const HISTORY_KEY = 'masterhub.unified-comparison.price-history.v1'

let memory: ComparisonPriceHistoryEntry[] | null = null

/**
 * ComparisonHistory — persists price snapshots (graph later in future sprint).
 */
export class ComparisonHistory {
  list(fingerprint?: string): ComparisonPriceHistoryEntry[] {
    const all = read()
    if (!fingerprint) return all
    return all.filter((e) => e.fingerprint === fingerprint)
  }

  recordOffers(offers: ComparisonOfferInput[]): ComparisonPriceHistoryEntry[] {
    const now = new Date().toISOString()
    const entries = offers.map((offer) => ({
      id: crypto.randomUUID(),
      productId: offer.product.id,
      fingerprint: offer.fingerprint,
      provider: offer.supplierId,
      price: offer.price,
      stock: offer.stock,
      delivery: offer.deliveryDays,
      createdAt: now,
    }))
    const next = [...entries, ...read()].slice(0, 2000)
    write(next)
    return entries
  }

  clear(): void {
    write([])
  }
}

function read(): ComparisonPriceHistoryEntry[] {
  if (typeof window === 'undefined') return memory ?? []
  return storageService.getJSON<ComparisonPriceHistoryEntry[]>(HISTORY_KEY, [])
}

function write(entries: ComparisonPriceHistoryEntry[]): void {
  memory = entries
  if (typeof window === 'undefined') return
  storageService.setJSON(HISTORY_KEY, entries)
}

export const comparisonHistory = new ComparisonHistory()
